module.exports = __webpack_public_path__ + "img/Spinning.506e86c5.png";